import React, { FC } from "react";
import { Badge, Button, Typography } from "@mui/material";
import { IContact } from "../types/Contact";
import { useContactEnrichment } from "../hooks/useContactEnrichment";
import { EnrichStatus } from "constants/const";

interface EnrichButtonProps {
  contact: IContact;
  refetchContactsData: () => void;
  handleOutOfCredits: () => unknown;
}

export const EnrichButton: FC<EnrichButtonProps> = ({
  contact,
  refetchContactsData,
  handleOutOfCredits,
}) => {
  const { handleEnrichClick, isLoading } = useContactEnrichment(
    contact.id as string,
    refetchContactsData,
    handleOutOfCredits,
  );

  return (
    <Button
      variant="contained"
      disabled={isLoading}
      disableRipple
      sx={{
        borderRadius: "10px",
        background:
          contact.enrich_status === EnrichStatus.COMPLETED
            ? "#d4d4d4"
            : "linear-gradient(94deg, #DA1B7D 1.16%, #FF643A 100%)",
        color: "white !important",
        height: "40px",
        width: "97px",
        mb: { xs: 2, md: 0 },
        textTransform: "none",
        position: "relative",
        fontWeight: "bold",
        "&:focus": {
          outline: "none",
          boxShadow: "none",
          color: "white !important",
        },
        "&:focus-visible": {
          outline: "none",
          boxShadow: "none",
          color: "white !important",
        },
        "&:hover": {
          background:
            contact.enrich_status === EnrichStatus.COMPLETED
              ? "#d4d4d4"
              : "linear-gradient(94deg, #DA1B7D 1.16%, #FF643A 100%)",
          color: "white !important",
        },
        "&:active": {
          color: "white !important",
        },
        "&.MuiButton-root": {
          color: "white !important",
        },
        "& .MuiButton-label": {
          color: "white !important",
        },
        "& .MuiButtonBase-root": {
          color: "white !important",
        },
        "& .MuiButton-text": {
          color: "white !important",
        },
        "& .MuiButton-contained": {
          color: "white !important",
        },
      }}
      onClick={e => {
        e.stopPropagation();
        handleEnrichClick(contact);
      }}
    >
      {contact.enrich_status === EnrichStatus.IN_PROGRESS || isLoading
        ? "Enriching..."
        : contact.enrich_status === EnrichStatus.COMPLETED
          ? "Enriched"
          : "Enrich"}
      <Badge
        sx={{
          position: "absolute",
          top: "-2px",
          right: "25px",
          "& .MuiBadge-badge": {
            bgcolor: "#E3E3E3",
            minWidth: "32px",
            height: "16px",
            borderRadius: "3px",
            padding: "2px 4px",
            fontSize: "10px",
            fontWeight: 600,
          },
        }}
        badgeContent={
          <Typography
            sx={{
              background: "linear-gradient(90deg, #DA1B7D, #FF643A)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: "10px",
              fontWeight: 600,
              lineHeight: 1,
            }}
          >
            Beta
          </Typography>
        }
      />
    </Button>
  );
};
